export enum ConnectionSlotState {
  Ready,
  BusyByAnotherUser,
  BusyByCurrentUser,
}

export function getUserFullNameWithLoginName(user: User) {
  let result = '';

  if (user.last_name) result = user.last_name;

  if (user.first_name && result.length > 0) result = user.first_name.substr(0, 1) + ' ' + result;

  if (result.length > 0) {
    if (user.username && user.username.length > 0) result += ' (' + user.username + ')';
  } else result = user.username;

  return result;
}
